import script from "./dbjl.vue?vue&type=script&setup=true&lang=js"
export * from "./dbjl.vue?vue&type=script&setup=true&lang=js"

import "./dbjl.vue?vue&type=style&index=0&id=993a3bd4&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-993a3bd4"]])

export default __exports__